import React from 'react';
import { Link } from 'react-router-dom';
import GridOverlay from '../components/GridOverlay';
import Brand from '../components/Brand';
import SEO from '../components/SEO';

export default function NotFound() {
    return (
        <>
            <SEO
                title="404 - Off the Access Road"
                description="The page you requested isn't in our yard."
                path="/404"
                noindex
            />
            <section
                className="relative flex min-h-[70vh] items-center overflow-hidden bg-brand-surface"
                data-testid="page-not-found"
            >
                <GridOverlay size={56} opacity={0.18} />
                <div className="relative z-10 mx-auto w-full max-w-7xl px-6 py-24 md:px-10">
                    <div className="mb-10">
                        <Brand height={64} />
                    </div>
                    <span className="eyebrow">Error / 404</span>
                    <h1 className="h-display mt-6 text-5xl sm:text-6xl lg:text-7xl">
                        Off the <span className="text-brand-gold">access road.</span>
                    </h1>
                    <p className="mt-6 max-w-xl font-sans text-base text-brand-muted">
                        The page you requested isn&apos;t in our yard. Let&apos;s get you
                        back on the corridor.
                    </p>
                    <div className="mt-10 flex flex-wrap gap-3">
                        <Link
                            to="/"
                            data-testid="404-cta-home"
                            className="bg-brand-gold px-5 py-3 font-display text-xs font-bold uppercase tracking-[0.14em] text-brand-base transition-colors duration-150 hover:bg-[#E5B647]"
                        >
                            Back to Home
                        </Link>
                        <Link
                            to="/contact"
                            data-testid="404-cta-contact"
                            className="border border-brand-hairline px-5 py-3 font-display text-xs font-bold uppercase tracking-[0.14em] text-brand-text transition-colors duration-150 hover:border-brand-gold hover:text-brand-gold"
                        >
                            Contact us
                        </Link>
                    </div>
                </div>
            </section>
        </>
    );
}
